<!-- 分成方结算列表 -->
<template>
  <scroll-layout class="fleet-match-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtonsSplitCount="5"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'partner:settle:list:apply'" type="plain" @click="apply">
              对账申请
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>

      <ykc-operation-dialog
        title="选择结算方"
        :before-confirm="partnerSelect"
        confirm-btn-txt="确定"
        :show.sync="showPartnerSelect">
        <div slot="content">
          <ykc-form ref="partnerForm" :model="partnerForm" :rules="partnerRules">
            <ykc-form-item label="站点" prop="stationId">
              <ykc-dropdown
                class="box-width box-width-left"
                :data="stationListData"
                v-model="partnerForm.stationId"
                @change="onStationChange"></ykc-dropdown>
            </ykc-form-item>
            <ykc-form-item label="结算方" prop="partnerId">
              <ykc-dropdown
                class="box-width box-width-left"
                :data="partnerListData"
                v-model="partnerForm.partnerId"
                @change="onPartnerChange"></ykc-dropdown>
            </ykc-form-item>
          </ykc-form>
        </div>
      </ykc-operation-dialog>
      <ykc-operation-dialog
        title="审批结算单"
        :before-confirm="() => auditSettle(statusEnum.PASS)"
        :before-cancel="() => auditSettle(statusEnum.NO_PASS)"
        confirm-btn-txt="审批通过"
        cancel-btn-txt="审批不通过"
        type="report"
        :show.sync="showAudit">
        <div slot="content">
          <ykc-form ref="auditForm" :model="auditForm" :rules="auditRules">
            <ykc-form-item label="审批备注" prop="auditRemark">
              <ykc-input
                v-model="auditForm.auditRemark"
                type="textarea"
                placeholder="备注"
                maxlength="500"></ykc-input>
            </ykc-form-item>
          </ykc-form>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>
<script>
  import YkcDialog from '@/components/ykc-ui/dialog';
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import { partnerSettleManage, partnerData, barrierPage } from '@/service/apis';
  import { code, offlineExport } from '@/utils';

  const PARTNER_SETTLE_STATUS = {
    APPLY: 1,
    NO_PASS: 2,
    PASS: 3,
    PAYMENT: 4,
  };

  const PARTNER_SETTLE_INVOICE_STATUS = {
    CONFIRM: 1,
    R_CONFIRM: 2,
  };

  export default {
    name: 'PartnerSettleList',
    components: {
      YkcOperationDialog,
    },
    data() {
      return {
        id: '',
        showPartnerSelect: false,
        showAudit: false,
        stationListData: [],
        partnerListData: [],
        allPartnerListData: [],
        partnerForm: {
          stationId: '',
          partnerId: '',
        },
        partnerRules: {
          stationId: [{ required: true, message: '请选择站点', trigger: 'change' }],
          partnerId: [{ required: true, message: '请选择结算方', trigger: 'change' }],
        },
        auditForm: {
          auditRemark: '',
        },
        auditRules: {
          auditRemark: [{ required: true, message: '请输入审批备注', trigger: 'blur' }],
        },
        partnerTypeData: [
          { id: '', name: '全部' },
          { id: 1, name: '物业集团' },
          { id: 2, name: '外部居间方' },
          { id: 3, name: '代建方' },
          { id: 4, name: '其他' },
        ],
        statusEnum: PARTNER_SETTLE_STATUS,
        invoiceStatusEnum: PARTNER_SETTLE_INVOICE_STATUS,
        statusData: [
          { id: '', name: '全部' },
          { id: PARTNER_SETTLE_STATUS.APPLY, name: '申请中' },
          { id: PARTNER_SETTLE_STATUS.NO_PASS, name: '审批未通过' },
          { id: PARTNER_SETTLE_STATUS.PASS, name: '审批通过' },
          { id: PARTNER_SETTLE_STATUS.PAYMENT, name: '已收款' },
        ],
        searchParams: {
          partnerType: '',
          partnerId: '',
          stationId: '',
          status: '',
          startDate: '',
          endDate: '',
        },
        tableTitle: '结算单列表',
        tableData: [],
        tableOperateButtons: [
          {
            render: (h, data, { row }) =>
              code('partner:settle:list:audit') && row.status === this.statusEnum.APPLY ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.id = row.id;
                    this.showAudit = true;
                  }}>
                  审批结算单
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('partner:settle:list:invoice') &&
              row.status === this.statusEnum.PASS &&
              row.invoiceStatus === this.invoiceStatusEnum.CONFIRM ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.invoice(row.id);
                  }}>
                  确认发票
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('partner:settle:list:pay') && row.status === this.statusEnum.PASS ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.payment(row.id);
                  }}>
                  确认收款
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportFile(row.id);
                }}>
                导出对账单
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetail(row.id);
                }}>
                导出明细
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetailExcel(row.id);
                }}>
                导出明细报表
              </ykc-button>
            ),
          },
          {
            enabled: () => code('partner:settle:list:detail'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.toDetail(row.id);
                }}>
                详情
              </ykc-button>
            ),
          },
        ],
        tableColumns: [
          { label: '结算单编号', prop: 'settleNo', minWidth: '200px' },
          { label: '结算时间', prop: 'settleTime', minWidth: '200px' },
          { label: '站点编码', prop: 'stationCode', minWidth: '200px' },
          { label: '站点名称', prop: 'stationName', minWidth: '200px' },
          { label: '结算方类型', prop: 'partnerTypeName', minWidth: '120px' },
          { label: '结算方名称', prop: 'partnerName', minWidth: '200px' },
          { label: '服务费结算方式', prop: 'serviceWayName', minWidth: '130px' },
          { label: '服务费分成', prop: 'serviceFeeSharing', minWidth: '150px' },
          { label: '服务费分成金额', prop: 'serviceFeeSharingAmount', minWidth: '150px' },
          { label: '总结算金额', prop: 'settleTotalAmount', minWidth: '150px' },
          { label: '审批状态', prop: 'statusName', minWidth: '120px' },
          { label: '发票状态', prop: 'invoiceStatusName', minWidth: '120px' },
          { label: '收款日期', prop: 'collectionDate', minWidth: '150px' },
          { label: '审核备注', prop: 'auditRemark', minWidth: '150px' },
          { label: '创建人', prop: 'createdBy', minWidth: '120px' },
          { label: '创建时间', prop: 'createTime', minWidth: '160px' },
        ],
        pageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDropdown',
            key: 'partnerType',
            label: '结算方类型',
            placeholder: '请选择结算方类型',
            data: this.partnerTypeData,
          },
          {
            comName: 'YkcDropdown',
            key: 'partnerId',
            label: '结算方名称',
            placeholder: '请选择结算方',
            data: this.allPartnerListData,
          },
          {
            comName: 'YkcDropdown',
            key: 'stationId',
            label: '站点名称',
            placeholder: '请选择站点',
            data: this.stationListData,
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '状态',
            placeholder: '请选择状态',
            data: this.statusData,
          },
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '创建时间',
            placeholder: '请选择创建时间',
          },
        ];
      },
    },
    mounted() {
      this.requestStationList();
      this.requestAllPartnerList();
      this.requestList();
    },
    watch: {
      // 监听路由变化，刷新列表
      $route: {
        handler(_, from) {
          // 从申请页返回时刷新
          if (from && from.path.includes('Apply')) {
            this.requestList();
          }
        },
        deep: true,
      },
      // 监听 refresh 参数，申请成功后刷新
      '$route.query.refresh': function (newVal) {
        if (newVal) {
          this.requestList();
        }
      },
    },
    methods: {
      requestStationList() {
        barrierPage
          .findStationList({})
          .then(res => {
            this.stationListData = (res || []).map(item => {
              return {
                id: item.stationId,
                name: item.stationName,
              };
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      requestAllPartnerList() {
        partnerData
          .getPartnerListDown()
          .then(res => {
            this.allPartnerListData = (res || []).map(item => {
              return {
                id: item.id,
                name: item.partnerName,
              };
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      requestPartnerList(stationId) {
        if (!stationId) {
          this.partnerListData = [];
          return;
        }
        partnerSettleManage
          .partnerListByStation({ stationId })
          .then(res => {
            this.partnerListData = (res || []).map(item => {
              return {
                id: item.id,
                name: `${item.partnerName}（${item.partnerTypeName}）`,
              };
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      onStationChange(val) {
        this.partnerForm.partnerId = '';
        this.requestPartnerList(val);
        this.$nextTick(() => {
          this.$refs.partnerForm.clearValidate(['stationId', 'partnerId']);
        });
      },
      onPartnerChange() {
        this.$nextTick(() => {
          this.$refs.partnerForm && this.$refs.partnerForm.clearValidate('partnerId');
        });
      },
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        partnerSettleManage
          .queryList(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      apply() {
        this.partnerForm.stationId = '';
        this.partnerForm.partnerId = '';
        this.partnerListData = [];
        this.showPartnerSelect = true;
        this.$nextTick(() => {
          this.$refs.partnerForm && this.$refs.partnerForm.clearValidate();
        });
      },
      partnerSelect() {
        this.$refs.partnerForm.validate(valid => {
          if (valid) {
            const { stationId, partnerId } = this.partnerForm;
            this.showPartnerSelect = false;
            this.$router.push({
              path: '/propertyStatistics/partnerSettlement/Apply',
              query: {
                stationId,
                partnerId,
              },
            });
            this.partnerForm.stationId = '';
            this.partnerForm.partnerId = '';
          }
        });
      },
      handleSearchConfirm(searchData) {
        this.pageInfo.current = 1;
        if (searchData.date && searchData.date.length) {
          [this.searchParams.startDate, this.searchParams.endDate] = searchData.date;
        } else {
          delete this.searchParams.startDate;
          delete this.searchParams.endDate;
        }
        Object.assign(this.searchParams, searchData);
        this.requestList();
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      toDetail(id) {
        this.$router.push({
          path: '/propertyStatistics/partnerSettlement/Detail',
          query: {
            id,
          },
        });
      },
      invoice(id) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '是否确认发票？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            partnerSettleManage.confirmInvoice({ id }).then(res => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.requestList();
              dialogDone();
            });
          },
        });
      },
      payment(id) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '是否确认收款？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            partnerSettleManage.confirmPayment({ id }).then(res => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.requestList();
              dialogDone();
            });
          },
        });
      },
      exportFile(id) {
        offlineExport({
          downloadType: 'finance_export',
          jsonNode: {
            downloadKey: 'partnerExportStatementList',
            id,
          },
        });
      },
      exportDetail(id) {
        offlineExport({
          downloadType: 'finance_export',
          jsonNode: {
            downloadKey: 'partnerExportDetailList',
            id,
          },
        });
      },
      exportDetailExcel(id) {
        // 获取单条结算单详情，获取真实的明细数量
        partnerSettleManage.getOne({ id }).then(detail => {
          offlineExport(
            {
              downloadType: 'finance_export',
              jsonNode: {
                downloadKey: 'partnerSettleDetailList',
                id,
              },
            },
            detail.settleDetail ? detail.settleDetail.length : 0
          );
        });
      },
      auditSettle(status) {
        this.$refs.auditForm.validate(valid => {
          if (valid) {
            if (status === PARTNER_SETTLE_STATUS.PASS) {
              this.$dialog({
                dialogType: 'feedback',
                showTitle: false,
                closeOnClickModal: false,
                desc: '确认审批通过？',
                onConfirm: done => {
                  const { auditRemark } = this.auditForm;
                  partnerSettleManage
                    .auditSettle({ id: this.id, status, auditRemark })
                    .then(res => {
                      this.$message({
                        message: '提交成功',
                        type: 'success',
                      });
                      this.auditForm.auditRemark = null;
                      this.requestList();
                      this.showAudit = false;
                    });
                  done();
                },
              });
              return;
            }
            const { auditRemark } = this.auditForm;
            partnerSettleManage.auditSettle({ id: this.id, status, auditRemark }).then(res => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.auditForm.auditRemark = null;
              this.requestList();
              this.showAudit = false;
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
